import { render, staticRenderFns } from "./mafiaways2.vue?vue&type=template&id=44079518&scoped=true"
import script from "./mafiaways2.vue?vue&type=script&lang=js"
export * from "./mafiaways2.vue?vue&type=script&lang=js"
import style0 from "./mafiaways2.vue?vue&type=style&index=0&id=44079518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44079518",
  null
  
)

export default component.exports